import getCookie from './getCookies';

/**
 * Get the authentication token from the _auth cookie
 * This replaces the problematic document.cookie?.split("=")[1].split(";")[0] pattern
 * which fails when other cookies (like Google cookies) appear before _auth
 */
export const getAuthToken = () => {
    const token = getCookie('_auth');
    return token || '';
};

/**
 * Get the authorization header for API requests
 */
export const getAuthHeader = () => {
    const token = getAuthToken();
    return token ? `Bearer ${token}` : '';
};

/**
 * Get the full headers object with authorization for API requests
 */
export const getAuthHeaders = () => {
    return {
        'Content-Type': 'application/json',
        'Authorization': getAuthHeader()
    };
};